
import { defineComponent } from "vue";
import InfoDialog from "@/components/info/InfoDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";

export default defineComponent({
  components: {
    InfoDialog,
    DxTabPanel,
    DxItem,
  },
  mixins: [mountComponentMixin],
  methods: {
    dialog() {
      return this.$refs.dialog as any;
    },
    open() {
      this.dialog().open();
    },
  },
});
